import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { MessageService, ConfirmationService } from "primeng/api";

@Directive()
export abstract class AbstractFormComponent<T> implements OnInit {
  @ViewChild("fileInput", { static: false }) fileInput!: ElementRef;

  abstract pageTitle: string;
  abstract form: FormGroup;
  abstract service: any;
  abstract idField: string;
  abstract formFields: string[];
  abstract initializeForm(): void;

  error: string | null = null;
  uploadError: string | null = null;
  element: T | null = null;

  protected fb = inject(FormBuilder);
  protected messageService = inject(MessageService);
  protected confirmationService = inject(ConfirmationService);
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  protected cdr = inject(ChangeDetectorRef);

  constructor(public path: string) {}

  ngOnInit(): void {
    this.initializeForm();

    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Edit";
      this.loadItem(+id);
    } else {
      this.pageTitle = "Create";
    }
  }

  loadItem(id: number): void {
    this.service.getId(id).subscribe({
      next: (res: T) => {
        if (res) {
          this.element = res;
          this.form.patchValue(res as any);
          this.cdr.detectChanges();
        }
      },
      error: (err: any) => (this.error = err),
    });
  }

  navigateAfterSave(): void {
    this.router.navigate(["/" + this.path]);
  }

  onSubmit(): void {
    const formData = new FormData();

    this.formFields.forEach((field) => {
      const control = this.form.get(field);
      if (control) {
        formData.append(field, control.value);
      }
    });

    const id = this.form.get(this.idField)?.value;

    if (id) {
      this.service.update(formData, id).subscribe({
        next: (res: any) => {
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.messageService.add({
              key: "myKey1",
              severity: "success",
              summary: "Success",
              detail: "Saved successfully",
            });
          }
        },
        error: (err: any) => (this.error = err),
      });
    } else {
      this.service.create(formData).subscribe({
        next: (res: any) => {
          if (res.status === "error") {
            this.uploadError = res.message;
          } else {
            this.navigateAfterSave();
          }
        },
        error: (err: any) => (this.error = err),
      });
    }
  }
}
